import { NumberInput } from '@chakra-ui/react';
import type { NumberInputRootProps } from '@chakra-ui/react';

export type NumberInputSize = Extract<NumberInputRootProps['size'], string>;

export interface NumberInputProps extends Pick<NumberInputRootProps, 'ids' | 'variant'> {
  value: number | null;
  min: number;
  max?: number;
  onValueChange: (valueAsNumber: number) => void;
  disabled?: boolean;
  invalid?: boolean;
  name?: string;
  readOnly?: boolean;
  ariaLabel?: string;
  maxDecimalPlaces?: number;
  formatOptions?: Intl.NumberFormatOptions;
  size?: NumberInputSize;
  placeholder?: string;
  textAlign?: 'start' | 'end';
}

const resolveFormatOptions = (
  formatOptions: Intl.NumberFormatOptions | undefined,
  maxDecimalPlaces: number | undefined
): Intl.NumberFormatOptions | undefined => {
  if (maxDecimalPlaces === undefined) {
    return formatOptions;
  }
  return { maximumFractionDigits: maxDecimalPlaces, ...formatOptions };
};

const VNumberInput = ({
  value,
  min,
  max,
  onValueChange,
  disabled,
  invalid,
  name,
  ids,
  variant,
  readOnly,
  ariaLabel,
  maxDecimalPlaces,
  formatOptions,
  size = 'lg',
  placeholder,
  textAlign,
}: NumberInputProps) => (
  <NumberInput.Root
    ids={ids}
    variant={variant}
    value={Number.isFinite(value) ? String(value) : ''}
    min={min}
    max={max}
    onValueChange={(details) => onValueChange(details.valueAsNumber)}
    size={size}
    disabled={disabled}
    invalid={invalid}
    name={name}
    readOnly={readOnly}
    formatOptions={resolveFormatOptions(formatOptions, maxDecimalPlaces)}
  >
    <NumberInput.Label />
    <NumberInput.Control>
      <NumberInput.IncrementTrigger />
      <NumberInput.DecrementTrigger />
    </NumberInput.Control>
    <NumberInput.Scrubber />
    <NumberInput.Input aria-label={ariaLabel} placeholder={placeholder} textAlign={textAlign} />
  </NumberInput.Root>
);

export default VNumberInput;
